// removed by extract-text-webpack-plugin
module.exports = {"glasspane":"PersonImporter__glasspane___3lwWV"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/PersonImporter/components/PersonImporter.scss
// module id = 1219
// module chunks = 1